<ap-amount-input
    [helpText]="'income.input.yearlyIncome.helpText' | apKeyOverride: contentKeyMap() | apContent"
    data-testid="yearlyIncome"
    [label]="'income.input.yearlyIncome' | apKeyOverride: contentKeyMap() | apContent"
    [numberOfDecimals]="numberOfDecimals()"
    [formControl]="incomeForm().controls.yearlyIncome | apFormControl"
    [messages]="yearlyIncomeErrorMessages"
    icon="calculator"
    (iconClick)="openMonthlyIncomeModal()"
>
</ap-amount-input>
